import {isAndroid, isIOS} from "@/utils/deviceCheck.js";
import { emitter } from '@/utils/eventBus'
import { EventKeys } from '@/utils/eventBus'

// 데이터 정규화 진행
//ex. AppToWeb -> iOS는 오브젝트 타입이므로 JSON.stringify 실행
//ex. AppToWeb -> Android는 문자열 타입이므로 그대로 전달
const normalizeInputData = (data) => {
    return typeof data === 'string' ? data : JSON.stringify(data)
}

// webToApp 브릿지 호출 핸들러
const bridgeHandler_WebToApp = (config) => {

    //bridgeHandler가 주입받는 브릿지메소드의 파라미터 데이터, 메소드 이름
    const { data = {}, methodName} = config;

    //아래 부분은 웹브라우저에서 userAgent만 바꿔서는 동작을 하지 않는다. 반드시 실제 갤럭시, 아이폰에서 검증을 해야 한다
    //특히 window[androidBridge][methodName] / window.webkit.messageHandlers[methodName] 이 부분은 데탑 크롬으로 검증할 수 없다
    if (isAndroid()) {
        //WebViewBridge는 AOS에서 'WebViewBridge' 라는 값으로 들어오는 웹뷰 요청을 캐치하고자 설정한 키 값이다. AOS:WEB 둘이 동일해야 함
        if (typeof window['WebViewBridge'] !== 'undefined' && window['WebViewBridge']) {
            window['WebViewBridge'][methodName]?.(JSON.stringify(data));
        } else {
            console.log(`${'WebViewBridge'} does not exist : aos`);
        }
    } else if (isIOS()) {
        if (window.webkit?.messageHandlers && window.webkit?.messageHandlers[methodName]) {
            window.webkit.messageHandlers[methodName].postMessage(data);
        } else {
            console.log(`${methodName} does not exist : ios`);
        }
    } else {
        window.opener?.postMessage(data);
    }
};

const bridgeHandler_AppToWeb = (methodType, data) => {
    switch(methodType) {
        case AppToWebBridgeMethodType.SCAN_QR_PRODUCT:
            // Android의 경우 이미 문자열로 전달되므로, 객체인 경우에만 stringify 실행
            const newInput = normalizeInputData(data)
            const parsedData = JSON.parse(newInput)
            emitter.emit(EventKeys.SCAN_QR_PRODUCT, parsedData)
            break;
    }
}

//vue.js에서 어떤 webToApp 브릿지메소드를 호출해야 하는지 정의된 enum
export const WebToAppBridgeMethodType = {
    WEB_TO_APP_LOGIN: 'WEB_TO_APP_LOGIN', //추후 로그인도 웹으로 이관될 시 필요할 듯 하여 일단 남겨둠
    WEB_TO_APP_LOGOUT: 'WEB_TO_APP_LOGOUT', //추후 로그아웃도 웹으로 이관될 시 필요할 듯 하여 일단 남겨둠 / 더보기 -> 로그아웃 -> 앱이 로그아웃 시 시행하는 절차(ex.토큰 삭제 및 특정 뷰 히든 처리)를 진행하도록 요청
    WEB_TO_APP_LOGOFF: 'WEB_TO_APP_LOGOFF', //추후 탈퇴도 웹으로 이관될 시 필요할 듯 하여 일단 남겨둠 / 더보기 -> 탈퇴하기 -> 앱이 탈퇴 시 시행하는 절차(ex.토큰 삭제 및 특정 뷰 히든 처리)를 진행하도록 요청
    WEB_TO_APP_CLOSE_NATIVE_VIEW: 'WEB_TO_APP_CLOSE_NATIVE_VIEW', // webToApp_ios aos앱에게 present된 화면 닫으라고 요청
    WEB_TO_APP_SCAN_QR_PRODUCT: 'WEB_TO_APP_SCAN_QR_PRODUCT', // webToApp_ios aos 앱에서 제품스캔 1건, 제품스캔 다중 요청
    WEB_TO_APP_WEBPAGE_TOKEN_EXPIRED: 'WEB_TO_APP_WEBPAGE_TOKEN_EXPIRED' //웹페이지에서 토큰이 만료된 경우, App은 사용자를 로그인 화면으로 보내거나, App이 들고 있는 인증값을 날리는 처리를 진행
}

//App에서 어떤 AppToWeb 브릿지메소드를 호출해야 하는지 정의된 enum
const AppToWebBridgeMethodType = {
    SCAN_QR_PRODUCT: 'APP_TO_WEB_SCAN_QR_PRODUCT'
}

/* WebToApp config

{
    // App에서 필요로 하는 파라미터. vue.js에서 앱으로 보낼 시 data는 아래와 같은 타입으로 작성해야 앱에서 받아서 처리할 수 있음
    data: data: { phoneNum: tel + '' } 혹은 { },

    // App에 등록된 webToApp 메소드 이름
    methodName: string
}

- TODO: swift Enum 처럼 enum이 associatedType을 받아서 enum하나만 파라미터로 받아도 내부에서 처리할수있게 하고 싶은데...어떻게 하지...
- _bridgeHandler 를 바로 vue단에서 쓰게 하자니, 왠지 bridge에 필요로 하는 파라미터를 한번 받고 분기를 하는 과정이 왠지 나중에 생길거 같음...

 */
export function createWebToAppBridgeConfig(value, data) {
    switch (value) {
        case WebToAppBridgeMethodType.WEB_TO_APP_LOGIN:
            return {methodName: 'requestWebToApp_Login', data: data}
        case WebToAppBridgeMethodType.WEB_TO_APP_LOGOUT:
            return {methodName: 'requestWebToApp_Logout', data: data}
        case WebToAppBridgeMethodType.WEB_TO_APP_LOGOFF:
            return {methodName: 'requestWebToApp_Logoff', data: data}
        case WebToAppBridgeMethodType.WEB_TO_APP_CLOSE_NATIVE_VIEW:
            return {methodName: 'requestWebToApp_closeNativeView', data: data}
        case WebToAppBridgeMethodType.WEB_TO_APP_SCAN_QR_PRODUCT:
            return {methodName: 'requestWebToApp_ScanQR_Product', data: data}
        case WebToAppBridgeMethodType.WEB_TO_APP_WEBPAGE_TOKEN_EXPIRED:
            return {methodName: 'requestWebToApp_WebPage_Token_Expired', data: data}
    }
};

/*
        웹 > 앱, 앱 > 웹 통신을 담당하는 메소드 모음.

        사용법:

        1. 본 파일 내 선언 및 메소드 구현
        2. App.vue > intBridges에서 window 객체에 바인딩
        3. 필요한 순간에 호출
*/
export const bridges = () => {
    return {
        //window를 통해서 webToApp 브릿지메소드를 호출해야 한다면 이 메소드드를 호출하면 됨
        requestWebToApp_commonMethod: (config) => {
            console.log(`bridges TEMP_requestWebToApp_commonMethod method BEGIN`);
            bridgeHandler_WebToApp(config);
            console.log(`bridges TEMP_requestWebToApp_commonMethod method END`);
        },

        //ios, aos에서 메소드를 호출 하여 웹페이지에 전달하려면 아래와 같이 evaluateJS 진행하면 됨
        //methodName: ex. APP_TO_WEB_SCAN_QR_PRODUCT
        //jsonString: ex. {"teethNos": [String], "arrayIndexex": [String], "productCode": [String]}
        requestAppToWeb_commonMethod: (methodType, data) => {
            console.log(`bridges TEMP_requestAppToWeb_commonMethod method BEGIN`);
            bridgeHandler_AppToWeb(methodType, data)
            console.log(`bridges TEMP_requestAppToWeb_commonMethod method END`);
        }
    }
}

//아래는 기 구현되어 있던 webToApp, AppToWeb 인데 일단 새로만든 브릿지가 정상동작 하는 것 확인 될 때까지는 주석처리만 하고 남겨 둔다
// export const bridges = () => {
//     return {
//         webToApp: (data) => {
//             const userAgent = navigator.userAgent.toLowerCase();
//             console.log(`webToApp, 디바이스: ${userAgent}, 수신 값: ${JSON.stringify(data)}`)
//             if (userAgent.indexOf('android') !== -1) {
//                 //안드로이드
//                 if (typeof WebViewBridge !== 'undefined' && WebViewBridge) {
//                     WebViewBridge?.webToApp(data);
//                 } else {
//                     console.log('WebViewBridge does not exist');
//                 }
//             } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) {
//                 // ios
//                 if (window.webkit?.messageHandlers && window.webkit?.messageHandlers?.webToApp) {
//                     window.webkit.messageHandlers.webToApp.postMessage(data);
//                 }
//             } else {
//                 //기타
//                 window.opener?.postMessage(data);
//             }
//         },
//         appToWeb: (input) => {
//             console.log(`appToWeb, 수신 파라미터: ${input}`)
//             const obj = {};
//             const newInput = JSON.stringify(input)
//             if(newInput && typeof newInput.accessToken !== 'undefined') {
//                 localStorage.setItem('accessTokenHos', newInput.accessToken);
//             }
//             if(newInput && typeof newInput.refreshToken !== 'undefined') {
//                 localStorage.setItem('refreshTokenHos', newInput.refreshToken);
//             }
//         },
//     }
// }

//  https://odd-mammals-cough.loca.lt/m/certificate-list